import React from 'react';

import FormFooter from 'platform/forms/components/FormFooter';
import SubTask from 'platform/forms/sub-task';
import { useBrowserMonitoring } from 'platform/monitoring/Datadog';
import { Element } from 'platform/utilities/scroll';
import {
  useFeatureToggle,
  TOGGLE_NAMES,
} from 'platform/utilities/feature-toggles';

import {
  GET_STARTED_TITLE,
  GET_STARTED_URL,
  DATA_DOG_ID,
  DATA_DOG_SERVICE,
  DATA_DOG_TOGGLE,
  DATA_DOG_TOKEN,
  DATA_DOG_VERSION,
} from '../constants';
import { wrapWithBreadcrumb } from '../utils';
import { PathHistoryProvider } from './utils/tracking/PathHistoryContext';
import { getResumePageName } from './utils';
import pages from './pages';
import screenerPages from './screener-pages';
import formConfig from '../config/form';

export const SubTaskContainer = () => {
  const { useToggleValue, useToggleLoadingValue } = useFeatureToggle();
  const togglesLoading = useToggleLoadingValue();
  const newScreenerQuestionFlow = useToggleValue(
    TOGGLE_NAMES.disability526NewScreenerQuestionFlow,
  );

  useBrowserMonitoring({
    toggleName: DATA_DOG_TOGGLE,
    applicationId: DATA_DOG_ID,
    clientToken: DATA_DOG_TOKEN,
    service: DATA_DOG_SERVICE,
    version: DATA_DOG_VERSION,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'mask',
    beforeSend: event => {
      // Prevent PII from being sent to Datadog with click actions.
      if (event.action?.type === 'click') {
        // eslint-disable-next-line no-param-reassign
        event.action.target.name = 'Clicked item';
      }
      return true;
    },
  });

  if (togglesLoading) {
    return (
      <va-loading-indicator message="Please wait while we load the application for you." />
    );
  }

  const activePages = newScreenerQuestionFlow ? screenerPages : pages;

  return wrapWithBreadcrumb(
    GET_STARTED_TITLE,
    <PathHistoryProvider>
      <article className="row">
        <div className="usa-width-two-thirds medium-8 columns vads-u-margin-bottom--2">
          <Element name="topContentElement" />
          <SubTask
            pages={activePages}
            getInitialPage={
              newScreenerQuestionFlow
                ? data => getResumePageName(activePages, data)
                : undefined
            }
          />
        </div>
      </article>
      <FormFooter formConfig={formConfig} />
    </PathHistoryProvider>,
    GET_STARTED_URL,
  );
};

export default SubTaskContainer;
